import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Preload from '../../layout/preload/Preload';
import InputSelect from '../../layout/input/InputSelect';

import TemaService from '../../../service/TemaService';

class InputSelectTema extends AbstractComponent {
    constructor(props) {
        super(props);  
        
        this.state = {
            temas: [{tema: {}, valor: 0, texto: 'Selecione'}],

            preload: false           
        }                
    }    

    onChangeSelect(input) {
        let tema = {};
        let lista = this.state.temas;        

        for(var i = 0; i < lista.length; i++) {                        
            if(parseInt(lista[i].valor, 10) === parseInt(input.target.value, 10)) 
                tema = lista[i].tema;                            
        }

        if (this.props.onChange !== undefined) 
            this.props.onChange(input, tema);        
    }
    
    componentDidMount() {                   
        this.setState({preload: true});

        TemaService.listar(

        ).then(resposta => {            
            let listas = this.state.temas;

            resposta.data.map(item => {
                listas.push({
                    tema: item,
                    valor: item.id, 
                    texto: item.descricao, 
                    selected: (parseInt(item.id, 10) === parseInt(this.props.editarId, 10))
                })
                
                return item;
            });            
            
            this.setState({
                temas: listas, 
                preload: false
            }); 
        }).catch(error => {            
            this.setState({
                preload: false,
                erro: this.trataErro(error)
            });            
        });        
    }            

    render() {
        return (    
            <Fragment>
                <Preload show={this.state.preload} />

                <InputSelect 
                    md={this.props.md} 
                    xs={this.props.xs} 
                    sm={this.props.sm} 
                    lg={this.props.lg} 
                    classNameInput={this.props.classNameInput}                        
                    nome={this.props.nome}                             
                    id={this.props.id} 
                    options={this.state.temas}
                    value={this.props.value}  
                    erro={this.props.erro}                           
                    onChange={e => this.onChangeSelect(e)}
                >                            
                    Tema
                </InputSelect>
            </Fragment>                        
        );
    }
}

export default InputSelectTema;